// tslint:disable:triple-equals
import { notification } from 'antd';
import { UploadFile } from 'antd/lib/upload/interface';
import * as React from 'react';
import { MutationFunc } from 'react-apollo';

import { imageUrl } from '../../../../../config/config';
import { convertProductImagesToUploadFiles } from '../../../../../helpers/convertProductImagesToUploadFiles';
import { matchImageWithAttributeValues } from '../../../../../helpers/Images/matchImageWithVariant';
import ValueImagesRow from '../ValueImagesRow';

export interface IVisualCombination {
  id: string;
  attributeValues: Array<GQL.IAttributeValue>;
}

interface IProductImagesProps {
  productImages: Array<GQL.IImage>;
  uniqueVisualCombinations?: Array<IVisualCombination>;
  productId: number;
  onChange: (images: Array<GQL.IImage>) => void;
  removeImage: Function;

  changePriorities?: MutationFunc;
  refetch: Function;
}

interface IProductImagesState {
  valueImages: Array<any>;
}

export default class ProductImages extends React.Component<IProductImagesProps, IProductImagesState> {

  constructor(props: IProductImagesProps) {
    super(props);

    this.state = {
      valueImages: [ ...props.productImages ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  public render() {
    return (
      <ValueImagesRow
        handleOrderChange={data => this.handleOrderChange(data)}
        handleChange={this.handleChange}
        handleRemove={this.handleRemove}
        productId={this.props.productId}
        url={imageUrl}
        valueImages={this.state.valueImages}
      />
    );
  }

  private handleRemove(p: UploadFile) {
    if (p.response) {
      return this.props.removeImage({ variables: { id: p.response.id } });
    }

    return this.props.removeImage({ variables: { id: p.uid } });
  }

  private async handleOrderChange(data: any) {
    this.handleChange(data);

    if (this.props.changePriorities) {
      // přetřídění před odesláním do backendu
      const resort = data.fileList
        .sort((a, b) => a.priority < b.priority ? -1 : 0)
        .map((f: any, i: number) => {
          f.priority = i + 1;
          return f;
        });

      // odeslání do backendu
      const result = await this.props.changePriorities({
        variables: {
          imagesToChange: resort.map(f => {
            return {
              id: f.id,
              newPriority: f.priority
            };
          })
        }
      });

      if (result.data.changePriorities) {
        notification[ 'success' ]({
          message: 'Info',
          description: `Order of images saved.`
        });
      }
    }
  }

  private handleChange({ fileList }: any) {
    if (fileList == undefined) {
      return;
    }

    const newFileList = fileList.map((i: any) => {
      if (i.originFileObj && !i.id && i.response) {
        return i.response;
      } else {
        return i;
      }
    });

    this.setState({
      valueImages: newFileList
    });
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductImagesTab/ProductImages/ProductImages.tsx